<template>
    <rkm-data-table
        :fields="fields.datatables.banners"
        :repository="repositories.banners"
        ref="DataTable"
        sort-by="ordem"
    >
        <template v-slot:cell(periodo)="{ item }">
            {{ formatDate(item.dataInicio) }} a {{ formatDate(item.dataFim) }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'parametrizacao-banner-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-parametrizacao-banner"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-parametrizacao-banner"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Libs.
import moment from 'moment'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    banners: [
                        {
                            name: 'parametrizacao_banner.ordem',
                            key: 'ordem',
                            label: 'Posição',
                            sortable: true,
                        },
                        {
                            name: 'parametrizacao_banner.titulo',
                            key: 'titulo',
                            label: 'Banner',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'parametrizacao_banner.origem',
                            key: 'origem',
                            label: 'Origem',
                            sortable: true,
                            searchable: true
                        },
                        {
                            name: 'parametrizacao_banner.data_inicio',
                            key: 'periodo',
                            label: 'Período',
                            sortable: true,
                        },
                        {
                            name: 'parametrizacao_banner_acao_tipo.descricao',
                            key: 'acaoTipo',
                            label: 'Ao tocar',
                            sortable: true,
                        },
                        {
                            name: 'situacao',
                            key: 'situacao',
                            label: 'Situação',
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            banners: this.getConectaSusRepository('parametrizacao.banners')
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.banners.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o banner?', destroy, this.handleError)
        },
        formatDate(data) {

            if (!data) return ''

            return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
    },
    mixins: [repository, error],
}
</script>
